import {
  Terminal,
  Home,
  RefreshCw,
  Clock,
  UploadCloud,
  BarChart2,
  Bell,
  Inbox,
} from "react-feather";


const sidebarLinks = [
  {
    href: "/",
    icon: Home,
    title: "Home",
  },
  {
    href: "/taps/mytaps",
    icon: RefreshCw,
    title: "Data Taps",
  },
  {
    href: "/sql/editor",
    icon: Terminal,
    title: "SQL Editor",
  },
  {
    href: "/jobs/overview",
    icon: Clock,
    title: "Scheduled Jobs",
  },
  {
    href: "/jobs/push",
    icon: UploadCloud,
    title: "Data Push",
  },
  {
    href: "/observability",
    icon: BarChart2,
    title: "Data Observability",
  },
  {
    href: "/crm",
    icon: Bell,
    title: "Campaigns",
  },
  {
    href: "/crm/inbox",
    icon: Inbox,
    title: "Inbox",
  },
];

export default sidebarLinks;
